// 和弦图
import ChartTemplate from '../ChartTemplate';

export default {
  extends: ChartTemplate,
  methods: {
    async initOptionAfter () {
      await require('highcharts/modules/sankey')(this.Highcharts);
      await require('highcharts/modules/dependency-wheel')(this.Highcharts);
    }
  }
}